import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#670600"
        }
    },
    typography: {
        "fontFamily": `Century Gothic, CenturyGothic, AppleGothic, sans-serif`,
        // "fontSize": 12,
        // "fontWeightLight": 300,
        // "fontWeightRegular": 400,
        // "fontWeightMedium": 500
    }
})

export default theme